module.exports = __webpack_public_path__ + "img/112.03e60a9a.jpg";